// Muss mit Buble compiliert werden!
class ChainablePromise {
    constructor(promise) {
        this.state = promise;
    }

    then(onFulfilled, onRejected) {
        this.state = this.state.then(onFulfilled, onRejected);
        return this;
    }

    static resolve(v) {
        let cp = new ChainablePromise();
        cp.state = Promise.resolve(v);
        return cp;
    }

    get promise() {
        return this.state;
    }
}

/**
 * Basisklasse für unser Achievement.
 */
class Achievement {
    constructor(icon, title, amount) {
        this._icon = icon;
        this._title = title;
        this._amount = amount
    }

    get title() {
        return this._title;
    }

    get icon() {
        return this._icon;
    }

    get amount() {
        return this._amount;
    }
}

/**
 * Repräsentiert den Container und handhabt die Anzeige von Achievements.
 */
class AchievementContainer {
    constructor($container, refreshUrl, refreshRate, stayTime) {
        this._container = $($container).hide();
        this._refreshRate = refreshRate;
        this._url = refreshUrl;
        this._stayTime = stayTime;
        this._run = false;
        this._template = Handlebars.compile(
            '<div class="achievement">' +
            '   <div class="achievement__icon">' +
            '       <img src="{{ icon }}">' +
            '   </div>' +
            '   <span class="achievement__title">{{ title }}</span>' +
            '   <span class="achievement__description">' +
            '       {{ amount }} <span class="fam-coins"></span>' +
            '   </span>' +
            '</div>'
        );
    }

    set template(template) {
        this._template = template;
    }

    get template() {
        return this._template;
    }

    /**
     * @param {Achievement} achievement
     * @returns {*}
     * @private
     */
    _displayAchievement(achievement) {
        return new Promise((resolve, reject) => {
            // display
            this._container.html(this.template(achievement));
            this._container.slideDown(500, () => {
                setTimeout(() => {
                    // hide
                    this._container.slideUp(500, () => {
                        resolve();
                    });
                }, this._stayTime);
            });
        });
    }

    /**
     * Ruft periodisch ab, ob neue Achievements gemacht wurden.
     */
    startWatch() {
        let watchFunc = () => {
            if (!this._run) {
                return;
            }

            this._doCheck()
                .then((data) => {
                    let promise = ChainablePromise.resolve();
                    data.map((achievement) => promise.then(() => this._displayAchievement(achievement)));
                    return promise.promise;
                })
                .then(
                    () => {
                        setTimeout(watchFunc, this._refreshRate)
                    },
                    () => {
                        setTimeout(watchFunc, this._refreshRate)
                    }
                )
        };

        this._run = true;
        return watchFunc();
    }

    /**
     * Ruft und Prüft ob ein Achievement vorliegt.
     * @private
     */
    _doCheck() {
        return new Promise((resolve, reject) => {
            jQuery
                .ajax({
                    url: this._url
                })
                .then((data) => {
                    data = data.map((value) => {
                        return new Achievement(value.icon, value.title, value.amount);
                    });
                    resolve(data);
                })
                .fail((data) => {
                    reject(data)
                });
        });
    }

    /**
     * Stoppt das abrufen der Achievements.
     */
    stopWatch() {
        this._run = false;
    }
}
